export const DATE_RANGE_DROPDOWN_VARIANTS = ['plain', 'outline'] as const;
export type DateRangeDropdownVariant = (typeof DATE_RANGE_DROPDOWN_VARIANTS)[number];
